module.exports = __webpack_public_path__ + "src/assets/img/m27.54bbb77c.svg";